var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":"button","disabled":_vm.isDisabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',{class:_vm.icon}),_c('span',[_vm._v(_vm._s(_vm.buttonLabel))])])}
var staticRenderFns = []

export { render, staticRenderFns }